<template>
  <div class="page-wrapper" :class="{'tnc-open': view === 'tnc'}" style="font-family: Pretendard;">
    <div class="tnc-topbar" v-if="merchant && view === 'tnc'">
      <button type="button" class="tnc-back-btn" @click="closeTnc(false)">‹ Back</button>
    </div>
    <div class="background-page" v-if="merchant">
      <div class="container purchase-container">
        <div v-if="view === 'shop' || view === 'basket'" class="shop-body">
          <div class="virtual-card">
            <div class="virtual-card-top">
              <div class="virtual-card-merchant-block">
                <div class="virtual-card-merchant">{{merchant.title}}</div>
                <div class="virtual-card-address" v-if="merchantAddress">{{merchantAddress}}</div>
              </div>
              <img class="virtual-card-icon" src="/static/img/gift_card_icon.png" alt=""/>
            </div>
            <div class="virtual-card-bottom">
              <div class="virtual-card-label">GIFT CARD</div>
              <div class="virtual-card-amount">£{{displayAmount}}</div>
            </div>
          </div>

          <div class="section-title">Select Amount</div>
          <div class="amount-grid">
            <div v-for="preset in presets" :key="'amt-' + preset"
                 class="amount-chip"
                 :class="{'selected': !customMode && amountPounds === preset}"
                 @click="selectPreset(preset)">
              £{{preset}}
            </div>
            <div class="amount-chip amount-chip-other"
                 :class="{'selected': customMode}"
                 @click="selectOtherAmount">
              Other Amount
            </div>
          </div>
          <div class="custom-amount-block" v-if="customMode">
            <div class="custom-amount-label">Other amount</div>
            <div class="custom-amount-field custom-active">
              <span class="pound-prefix">£</span>
              <input type="number" min="1" max="1000" step="1"
                     ref="customAmountInput"
                     v-model.number="customAmount"
                     @input="onCustomAmount"
                     placeholder="Enter amount"/>
            </div>
          </div>

          <div class="sticky-cta">
            <div v-if="errorMessage" class="shop-error">{{errorMessage}}</div>
            <button class="add-basket-btn" @click="goBasket">
              <img src="/static/img/basket_container.png" alt=""/>
              Add to basket
            </button>
          </div>
        </div>

        <transition name="sheet">
        <div v-if="view === 'basket'" class="basket-overlay" @click.self="view = 'shop'">
        <div class="basket-sheet basket-body">
          <div class="basket-summary-title">Basket Summary</div>
          <div class="virtual-card basket-card">
            <div class="virtual-card-top">
              <div class="virtual-card-merchant-block">
                <div class="virtual-card-merchant">{{merchant.title}}</div>
                <div class="virtual-card-address" v-if="merchantAddress">{{merchantAddress}}</div>
              </div>
              <img class="virtual-card-icon" src="/static/img/gift_card_icon.png" alt=""/>
            </div>
            <div class="virtual-card-bottom">
              <div class="virtual-card-label">GIFT CARD</div>
              <div class="virtual-card-amount">£{{selectedAmount.toFixed(2)}}</div>
            </div>
          </div>
          <div class="form-block">
            Email <span class="mandatory-text">*</span>
            <input type="email" class="form-control" v-model="email" placeholder="email@example.com"/>
          </div>
          <div class="form-block">
            Name <span class="optional-text">(optional)</span>
            <input type="text" class="form-control" v-model="name" placeholder="Name"/>
          </div>
          <div class="form-block">
            Phone number <span class="optional-text">(optional)</span>
            <input type="tel" class="form-control" v-model="phone" placeholder="Phone"/>
          </div>
          <div class="form-block tnc-block">
            <span class="tnc-check" @click="acceptedTnc = !acceptedTnc">
              <i v-if="acceptedTnc" class="fas fa-check-square" style="color:#2F77E4;"></i>
              <i v-else class="far fa-square"></i>
            </span>
            <span>
              I agree to the
              <a href="#" class="tnc-link" @click.prevent="openTnc(false)">Terms and Conditions</a>
              of {{merchant.title}}. {{merchant.title}} is the seller of this gift card.
            </span>
          </div>
          <div class="basket-actions">
            <button class="positive-button checkout-btn" @click="checkout" :disabled="paying">Pay with card</button>
            <button class="back-btn" @click="view = 'shop'">Back</button>
          </div>
          <div v-if="errorMessage" class="basket-error">{{errorMessage}}</div>
        </div>
        </div>
        </transition>

        <div v-if="view === 'tnc'">
          <GiftCardTnC :merchant="merchant" :amount="selectedAmount"/>
          <div v-if="!tncReadOnly" style="padding: 10px 15px 30px 15px;">
            <button class="positive-button checkout-btn" @click="closeTnc(true)">I agree</button>
          </div>
        </div>

        <div class="page-footer" v-if="view !== 'tnc'">
          <button type="button" class="tnc-footer-btn" @click="openTnc(true)">Terms & Conditions</button>
          <div class="footer-merchant">
            <strong>{{merchant.title}}</strong>
            <div v-if="merchantAddress">{{merchantAddress}}</div>
          </div>
          <div class="powered-by">
            Powered by <strong>Borium Studio Limited</strong>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="errorMessage" style="padding: 40px; text-align:center;">{{errorMessage}}</div>
    <div v-else class="page-gif-loader">
      <UtensilLoader/>
    </div>
  </div>
</template>

<script>
import {getGiftCardMerchant, getMerchant, getMerchantPermalink, getMerchantUrl, purchaseGiftCard} from "../api/borium";
import GiftCardTnC from "./GiftCardTnC.vue";
import UtensilLoader from "./UtensilLoader.vue";

export default {
  name: 'GiftCard',
  components: { GiftCardTnC, UtensilLoader },
  data() {
    return {
      merchant: false,
      view: 'shop',
      presets: [10, 20, 50, 100, 200],
      amountPounds: 50,
      customMode: false,
      customAmount: null,
      email: '',
      name: '',
      phone: '',
      acceptedTnc: false,
      tncFrom: 'shop',
      tncReadOnly: false,
      errorMessage: '',
      stripe: null,
      paying: false,
    }
  },
  computed: {
    selectedAmount: function() {
      if (this.customMode) {
        return parseFloat(this.customAmount) > 0 ? parseFloat(this.customAmount) : 0;
      }
      return this.amountPounds;
    },
    displayAmount: function() {
      let n = this.selectedAmount;
      if (!n) {
        return '0';
      }
      if (Math.round(n) === n) {
        return String(n);
      }
      return n.toFixed(2);
    },
    merchantAddress: function() {
      if (!this.merchant) {
        return '';
      }
      let parts = [];
      if (this.merchant.address) {
        parts.push(String(this.merchant.address).replace(/\n/g, ', '));
      }
      if (this.merchant.city) parts.push(this.merchant.city);
      if (this.merchant.postCode) parts.push(this.merchant.postCode);
      return parts.join(', ');
    },
    subscriptionId: function() {
      if (!this.merchant) {
        return 0;
      }
      if (this.merchant.subscriptionId) {
        return this.merchant.subscriptionId;
      }
      if (this.merchant.merchantId) {
        return this.merchant.merchantId;
      }
      return this.merchant.id;
    }
  },
  watch: {
    view: function(newView, oldView) {
      if (newView !== 'tnc' && oldView !== 'tnc') {
        return;
      }
      this.$nextTick(function() {
        if (this.$el) {
          this.$el.scrollTop = 0;
        }
      });
    }
  },
  mounted() {
    this.loadMerchant();
  },
  beforeDestroy() {
    if (this.loaderPreviewTimer) {
      clearTimeout(this.loaderPreviewTimer);
    }
  },
  methods: {
    selectPreset: function(preset) {
      this.customMode = false;
      this.amountPounds = preset;
      this.customAmount = null;
      this.errorMessage = '';
    },
    selectOtherAmount: function() {
      this.customMode = true;
      this.errorMessage = '';
      let self = this;
      this.$nextTick(function() {
        if (self.$refs.customAmountInput) {
          self.$refs.customAmountInput.focus();
        }
      });
    },
    onCustomAmount: function() {
      this.customMode = true;
      this.errorMessage = '';
    },
    loadMerchant: function() {
      let self = this;
      if (this.$route.params.permalink) {
        getMerchantPermalink(this.$route.params.permalink)
          .then(function(data) {
            self.applyMerchant(data);
          })
          .catch(function() {
            self.loadFromSpring();
          });
        return;
      }
      if (this.$route.params.id) {
        getMerchant(this.$route.params.id)
          .then(function(data) {
            self.applyMerchant(data);
          })
          .catch(function() {
            self.loadFromSpring();
          });
        return;
      }
      let host = window.location.host;
      getMerchantUrl('https://' + host)
        .then(function(data) {
          if (data.success) {
            self.applyMerchant(data);
          } else {
            self.loadFromSpring();
          }
        })
        .catch(function() {
          self.loadFromSpring();
        });
    },
    loadFromSpring: function() {
      let self = this;
      getGiftCardMerchant(this.$route.params.id, this.$route.params.permalink, window.location.host)
        .then(function(data) {
          if (data.success && data.item) {
            self.merchant = data.item;
          } else {
            self.errorMessage = data.message || 'Cannot find restaurant';
          }
        })
        .catch(function() {
          self.errorMessage = 'Cannot find restaurant';
        });
    },
    applyMerchant: function(data) {
      if (data.success === true && data.item) {
        this.merchant = data.item;
        this.refreshMerchantFromSpring();
      } else {
        this.loadFromSpring();
      }
    },
    keepMerchantDetails: function(fromPhp, fromSpring) {
      if (!fromSpring) {
        return fromPhp;
      }
      if (!fromPhp) {
        return fromSpring;
      }
      let merged = Object.assign({}, fromSpring);
      if (!merged.address && fromPhp.address) {
        merged.address = fromPhp.address;
      }
      if (!merged.city && fromPhp.city) {
        merged.city = fromPhp.city;
      }
      if (!merged.postCode && fromPhp.postCode) {
        merged.postCode = fromPhp.postCode;
      }
      if (!merged.phoneNumber && fromPhp.phoneNumber) {
        merged.phoneNumber = fromPhp.phoneNumber;
      }
      if (!merged.registeredTitle && fromPhp.registeredTitle) {
        merged.registeredTitle = fromPhp.registeredTitle;
      }
      if (!merged.logo && fromPhp.logo) {
        merged.logo = fromPhp.logo;
      }
      if (!merged.logo && fromPhp.imageUrl) {
        merged.logo = String(fromPhp.imageUrl).split(',')[0];
      }
      return merged;
    },
    refreshMerchantFromSpring: function() {
      let self = this;
      getGiftCardMerchant(this.subscriptionId, this.$route.params.permalink, window.location.host)
        .then(function(data) {
          if (data.success && data.item) {
            self.merchant = self.keepMerchantDetails(self.merchant, data.item);
          }
        });
    },
    goBasket: function() {
      if (this.selectedAmount < 1 || this.selectedAmount > 1000) {
        this.errorMessage = 'Choose an amount between £1 and £1,000';
        return;
      }
      this.errorMessage = '';
      this.view = 'basket';
    },
    openTnc: function(readOnly) {
      if (this.view !== 'tnc') {
        this.tncFrom = this.view;
        this.tncReadOnly = !!readOnly;
      }
      this.view = 'tnc';
      this.$nextTick(function() {
        if (this.$el) {
          this.$el.scrollTop = 0;
        }
      });
    },
    closeTnc: function(agree) {
      if (agree) {
        this.acceptedTnc = true;
      }
      this.view = this.tncFrom || 'shop';
    },
    checkout: function() {
      if (!this.email || this.email.indexOf('@') < 0) {
        this.errorMessage = 'Email is required';
        return;
      }
      if (this.selectedAmount < 1 || this.selectedAmount > 1000) {
        this.errorMessage = 'Enter an amount between £1 and £1,000';
        return;
      }
      if (!this.acceptedTnc) {
        this.errorMessage = 'Please agree to the Terms and Conditions';
        return;
      }
      this.errorMessage = '';
      this.paying = true;
      let self = this;
      let payload = {
        subscriptionId: this.subscriptionId,
        merchantId: this.merchant.id || 0,
        permalink: this.$route.params.permalink || '',
        amount: Math.round(this.selectedAmount * 100),
        email: this.email.trim().toLowerCase(),
        name: this.name,
        phone: this.phone,
        sendAsGift: false,
        recipientEmail: '',
        giftMessage: '',
        redirectUrl: window.location.origin,
      };
      this.$nextTick(function() {
        purchaseGiftCard(payload)
          .then(function(data) {
            self.paying = false;
            if (!data.success) {
              self.errorMessage = data.message || 'Could not start payment';
              return;
            }
            let item = data.item;
            if (item.teyaSessionUrl) {
              window.location.href = item.teyaSessionUrl;
              return;
            }
            if (item.stripePublicKey) {
              if (item.stripeClientId) {
                self.stripe = Stripe(item.stripePublicKey, {stripeAccount: item.stripeClientId});
              } else {
                self.stripe = Stripe(item.stripePublicKey);
              }
              return self.stripe.redirectToCheckout({sessionId: item.pgToken});
            }
            console.error('Request failed');
            self.errorMessage = 'Could not start payment';
          })
          .catch(function(err) {
            self.paying = false;
            console.error('Request failed', err && err.response ? err.response.status : '');
            self.errorMessage = 'Could not start payment. Please try again.';
          });
      });
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #f3f4f6;
  box-sizing: border-box;
  padding-top: 0;
}
.page-wrapper.tnc-open {
  padding-top: 0;
}
.tnc-topbar {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  background: white;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 8px;
  box-sizing: border-box;
}
.tnc-back-btn {
  background: none;
  border: none;
  color: #102E5A;
  font-weight: 700;
  font-size: 16px;
  padding: 10px 12px;
  cursor: pointer;
}
.background-page {
  background: #f3f4f6;
  min-height: 100%;
}
.basket-summary-title {
  padding: 10px 0;
  font-size: 20px;
  font-weight: 700;
}
.amount-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
}
.amount-chip {
  width: calc(33.33% - 12px);
  margin: 6px;
  padding: 14px 0;
  text-align: center;
  border: 1px solid #d8dce3;
  border-radius: 12px;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  background: #fff;
  color: #031635;
  box-sizing: border-box;
}
.amount-chip.selected {
  background: #031635;
  color: white;
  border-color: #031635;
}
.amount-chip-other {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  padding: 14px 8px;
}
.basket-card {
  margin-bottom: 20px;
}
.form-block {
  text-align: left;
  padding: 8px 0;
}
.tnc-block {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.4;
}
.tnc-check {
  font-size: 22px;
  margin-right: 10px;
  cursor: pointer;
  line-height: 1;
}
.tnc-link {
  color: #2F77E4;
  text-decoration: underline;
}
.mandatory-text {
  color: #E84725;
}
.optional-text {
  color: #888;
  font-size: 13px;
}
.checkout-btn {
  padding: 16px 50px;
  border: none;
  width: 100%;
  background: #031635;
  color: white;
  font-weight: bold;
  border-radius: 12px;
}
.back-btn {
  margin-top: 10px;
  width: 100%;
  padding: 12px;
  border: none;
  background: #eee;
  border-radius: 10px;
}
.basket-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(3, 22, 53, 0.45);
  z-index: 300;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.basket-sheet {
  background: #f3f4f6;
  width: 100%;
  max-width: 600px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 16px 28px 16px;
  box-sizing: border-box;
}
.sheet-enter-active,
.sheet-leave-active {
  transition: opacity 0.3s ease;
}
.sheet-enter-active .basket-sheet,
.sheet-leave-active .basket-sheet {
  transition: transform 0.3s ease;
}
.sheet-enter,
.sheet-leave-to {
  opacity: 0;
}
.sheet-enter .basket-sheet,
.sheet-leave-to .basket-sheet {
  transform: translateY(100%);
}
.purchase-container.container,
.purchase-container {
  position: relative;
  background: #f3f4f6;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}
.page-footer {
  margin-top: auto;
  padding: 28px 15px 36px 15px;
  border-top: 1px solid #eee;
  text-align: center;
}
.tnc-footer-btn {
  display: inline-block;
  background: #f3f4f7;
  border: none;
  border-radius: 10px;
  color: #102E5A;
  font-weight: 700;
  font-size: 14px;
  padding: 12px 22px;
  cursor: pointer;
}
.footer-merchant {
  margin-top: 16px;
  font-size: 13px;
  color: #333;
  line-height: 1.45;
}
.powered-by {
  margin-top: 12px;
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
.shop-body,
.basket-body {
  padding: 20px 0 8px 0;
  text-align: left;
}
.basket-sheet.basket-body {
  padding: 20px 16px 28px 16px;
}
@media (min-width: 600px) {
  .shop-body,
  .basket-body {
    padding-left: 18px;
    padding-right: 18px;
  }
}
.virtual-card {
  background: linear-gradient(145deg, #0a2a52 0%, #031635 55%, #021024 100%);
  border-radius: 18px;
  min-height: 190px;
  padding: 22px 22px 20px 22px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 8px 24px rgba(3, 22, 53, 0.28);
}
.virtual-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.virtual-card-merchant-block {
  min-width: 0;
  padding-right: 12px;
}
.virtual-card-merchant {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.2;
}
.virtual-card-address {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  opacity: 0.8;
}
.virtual-card-icon {
  width: 35px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}
.virtual-card-label {
  font-size: 12px;
  letter-spacing: 0.08em;
  opacity: 0.9;
  font-weight: 600;
}
.virtual-card-amount {
  font-size: 36px;
  font-weight: 600;
  line-height: 1.15;
  margin-top: 2px;
}
.section-title {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin: 28px 0 14px 0;
}
.custom-amount-block {
  margin-top: 18px;
}
.custom-amount-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}
.custom-amount-field {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dce3;
  border-radius: 12px;
  padding: 0 14px;
}
.custom-amount-field.custom-active {
  border-color: #031635;
}
.pound-prefix {
  color: #888;
  font-size: 16px;
  margin-right: 6px;
}
.custom-amount-field input {
  border: none;
  outline: none;
  width: 100%;
  height: 48px;
  font-size: 16px;
  background: transparent;
}
.sticky-cta {
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 20px;
  padding: 10px 0 14px 0;
  background: linear-gradient(180deg, rgba(243,244,246,0) 0%, #f3f4f6 40%);
}
.add-basket-btn {
  width: 100%;
  border: none;
  background: #031635;
  color: #fff;
  font-weight: 500;
  font-size: 17px;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}
.add-basket-btn img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  mix-blend-mode: screen;
}
.shop-error {
  margin-bottom: 10px;
  color: #c00;
  text-align: center;
}
.basket-actions {
  padding: 20px 0;
}
.basket-error {
  padding: 0 0 20px 0;
  color: #c00;
}
</style>



// WEBPACK FOOTER //
// src/components/GiftCard.vue